<template>
  <div>
    <div>
      <!-- Start the code for this screen here -->
      <div>
        <div>
          <!-- <nav class="navbar navbar-expand-lg bg-info text-white">
            <span>
              <b>Deal Information</b>
            </span>
          </nav>-->
        </div>
        <center :style="msgcolor">{{ searchMessage }}</center>
        
        <div
          class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          "
        >
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2 mt-5
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Lease </label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-5
            "
            v-if="this.dealIds.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="dealerName"
              :options="dealIds"
              v-model="deal.loanId"
              class="multiselectinactive"
              selected="selected"
              placeholder="Select a Lease"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-5
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2 mt-5
            "
          >
            <label for="quote" class="col-form-label col-form-label-sm"
              >Loan Created Date Range</label
            >
          </div>
          <div
            class="
              col-12
              mr-2
              col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-5
            "
          >
            <input
              type="Date"
              v-validate="'required'"
              v-model="deal.startDate"
              @change="getStartDate()"
              class="form-control input-sm"
              name="DFrom"
              data-vv-as="Date Range"
            />
            <span class="alert-danger">{{ startDateMessage }}</span>
          </div>
          <div class="col-sm-6 d-none d-sm-block d-md-none"></div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-5
            "
          >
            <input
              type="Date"
              class="form-control input-sm"
              v-model="deal.endDate"
              @change="getEndDate()"
              v-validate="'required'"
              name="DFrom"
              data-vv-as="Date Range"
            />
            <span class="alert-danger">{{ endDateMessage }}</span>
          </div>
        </div>
        <div
          class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          "
        >
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Salesperson Name</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvSalesPersons.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="agentName"
              :options="dmvSalesPersons"
              v-model="deal.agentName"
              selected="selected"
              placeholder="Select a Salesperson Name"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Dealer Name</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvDealerNames.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="dealerName"
              v-model="deal.dealerName"
              :options="dmvDealerNames"
              selected="selected"
              placeholder="Select a DealerName"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
        </div>
        <div
          class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          "
        >
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Lessee Name</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvLesseeNames.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="lesseeName"
              placeholder="Select a Lessee Name"
              v-model="deal.customerName"
              :options="dmvLesseeNames"
              selected="selected"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Make</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvMake.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="make"
              v-model="deal.selectedMake"
              :options="dmvMake"
              selected="selected"
              placeholder="Select Make"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
        </div>
        <div
          class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          "
        >
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm mr-2"
              >Dealbook State</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvDealerStates.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="dealerState"
              v-model="deal.selectedDealerState"
              :options="dmvDealerStates"
              selected="selected"
              placeholder="Select a Dealbook State"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Year</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvYear.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="year"
              v-model="deal.selectedYear"
              :options="dmvYear"
              selected="selected"
              placeholder="Select Year"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
        </div>
        <div
          class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          "
        >
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >DMV Title Milestone</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvLoanStatus.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="status"
              v-model="deal.loanStatus"
              :options="dmvLoanStatus"
              v-bind:value="dmvLoanStatus.loanStatus"
              v-bind:key="dmvLoanStatus.statusId"
              :custom-label="customLabel"
              selected="selected"
              placeholder="Select DMV Title Status"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Model</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvModel.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="Model"
              v-model="deal.selectedModel"
              :options="dmvModel"
              selected="selected"
              placeholder="Select Model"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
        </div>
        <div
          class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          "
        >
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Dealer Dmv</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dealerDmv.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="status"
              v-model="deal.dealerDmv"
              :options="dealerDmv"
              selected="selected"
              placeholder="Select Dealer Dmv"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
          


 <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Vin</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.dmvVin.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="vin"
              v-model="deal.selectedVin"
              :options="dmvVin"
              selected="selected"
              placeholder="Select Vin"
              @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>



        
        </div>
         <div
          class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          "
        >
          <div
            class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            "
          >
            <label for="source" class="col-form-label col-form-label-sm"
              >Stop Reminder Flag</label
            >
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-if="this.reminderFlag.length != 0"
          >
            <multiselect
              style="width: 100%"
              name="status"
              v-model="deal.reminderFlag"
              :options="reminderFlag"
              selected="selected"
              placeholder="Select Reminder Flag"
               @input="getDMVSearch()"
            ></multiselect>
          </div>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
            v-else
          >
            <input type="text" disabled placeholder="No data available" />
          </div>
       
        </div>
        <br />
        <center>
          <div
            class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            "
          >
            <!-- <button
                type="submit"
                class="btn btn-secondary mb-2 mr-3"
                @click="getDMVSearch()"
              >
                Search
              </button>-->

            <button
              type="submit"
              class="btn btn-secondary mb-2 mr-3"
              @click="resetSearchCriteria()"
            >
              Reset
            </button>
          </div>
        </center>
        <br />
        
        <br />
        <div role="tabpanel" class="tab-pane" id="documentstab">
          <div>
            <nav>
              <span>
                <b>DMV Leases</b>
              </span>
            </nav>
          </div>
        </div>
        <!-- Modal content-->
        <div id="myModal" class="modal">
          <div class="loader">
            <div class="cogs">
              <div class="cog cog0">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div>
          <div class="row no-gutters p-2 justify-content-center rowWrap">
            <div class="col">
              <div
                class="table-responsive table-responsive-sm"
                style=" overflow: auto" 
              >
                <v-table
                  id="myappsTable"
                  :data="dmvTitleDataList"
                  :currentPage.sync="currentPage"
                  :pageSize="50"
                  @totalPagesChanged="totalPages = $event"
                  class="table table-sm table-bordered table-striped"

                >
                  <thead class="table-month-header-blue wrap-text" slot="head">
                    <v-th sortKey="loan">Select</v-th>
                    <v-th sortKey= "notes">Notes</v-th>
                    <v-th sortKey="loan">Lease</v-th>
                    <v-th sortKey="dmvTitleStatus">Status</v-th>
                    <v-th sortKey="dealbookRegistrationState"
                      >Deal State</v-th
                    >
                   
                  
                    <v-th sortKey="dealerDMV">Dealer 
                      <br>DMV</v-th>
                    <v-th sortKey="borrowername">Lessee Name</v-th>
                   
                    <v-th sortKey="year">Year</v-th>
                    <v-th sortKey="make">Make</v-th>
                    <v-th sortKey="mpdel">Model</v-th>
                    <v-th sortKey="color">Color</v-th>
                    <v-th sortKey="vin">Vin</v-th>
 <v-th sortKey="dateOfSaleToLLP">Funding Date</v-th>
                  </thead>
                  <tbody slot="body" slot-scope="{ displayData }">
                    <tr v-for="(deal, index) in displayData" class="col-form-label col-form-label-sm">
                      <td>
                        <input
                          type="radio"
                          v-model="selecteddeal"
                          @click="selectedDeal(deal)"
                          v-bind:value="deal.loan"
                        />
                      </td>
                      <td>
                        <a
                          class="btn btn-secondary"
                          @click="selectedNotes('notes', deal.id)"
                          >Notes</a
                        >
                      </td>
                      <td>{{ deal.loan }}</td>
                      <td>{{ deal.dmvTitleStatus }}</td>
                      <td>{{ deal.dealbookRegistrationState }}</td>
                   
                    
                      <td>{{ deal.dealerDMV }}</td>
                      <td>{{ deal.borrowername }}</td>
                    
                      <td>{{ deal.year }}</td>
                      <td>{{ deal.make }}</td>
                      <td>{{ deal.model }}</td>
                      <td>{{ deal.color }}</td>
                      <td>{{ deal.vin }}</td>
  <td>{{ deal.dateOfSaleToLLP | moment("MM/DD/YYYY") }}</td>
                    </tr>
                  </tbody>
                </v-table>
                <smart-pagination
                  :currentPage.sync="currentPage"
                  :totalPages="totalPages"
                  
                />
              </div>
            </div>
          </div>
        </div>
        <br>
        <nav class="navbar navbar-expand-lg bg-info text-white">
          <span>
            <b>Manage MV Service Providers Contacts</b>
          </span>
        </nav>
        <br />
        <center>
          <span :style="msgcolor">{{ uploadingMessage }}</span>
          <span :style="msgcolor">{{ recordsUploaded }}</span>
        </center>
        <center>
          <div
            class="row no-gutters row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2"
          >
            <div
              class="
                col-12 col-md-12
                d-flex
                justify-content-lg-end
                align-items-center
              "
            >
              <label class="col-form-label col-form-label-sm"
                >Manage MV Service Providers Contacts</label
              >
            </div>
            <div
              class="
                col-12 col-md-12
                justify-content-end
                align-items-center
                mb-3 mb-lg-0 mb-md-3 mb-sm-3
              "
            >
              <input
                type="file"
                class="form-control input-sm"
                @change="onFileSelected"
                id="uploadfile"
              />
              <span class="alert-danger">{{ message }}</span>
            </div>
            <div
              class="
                col-12 col-md-12
                justify-content-end
                align-items-center
                mb-3 mb-lg-0 mb-md-3 mb-sm-3
              "
            >
              <button class="btn btn-secondary mr-3 mb-2" @click="onUpload">
                Upload
              </button>
            </div>
            <div
              class="
                col-12 col-md-12
                justify-content-end
                align-items-center
                mb-2 mb-md-2 mb-lg-0 mb-sm-2
              "
            >
        
              <download-csv 
                :name="serviceProviderExport"
                title="ServiceProviderExport"
                worksheet="ServiceProvider Data"
                :data="serviceProviders"
              >
                <button
                  class="btn btn-secondary mr-3"
                  @click="getDMVServiceProvider()"
                >
                  MV Service Providers Export
                </button>
              </download-csv>
            </div>
          </div>
        </center>
      </div>
    </div>
  </div>
</template>
<script>
import httpdmvtitle from "../js/http-dmvtitledata.js";
import multiselectcss from "@/css/vue-multiselect.min.css";
import { bus } from "../main";
import $ from "jquery";
import moment from "moment";
export default {
  components: { multiselectcss },
  name: "autopalData",
  data() {
    return {
      loanStatusData:"",
      dmvNotesList: [],
      heads: [
        { name: "Select" },
        { name: "Deal" },
        { name: "Borrower Name" },
        { name: "Year" },
        { name: "Make" },
        { name: "Model" },
        { name: "Color" },
        { name: "Vin" },
        { name: "Loan Creation" },
        { name: "Funding Date" },
        { name: "Dealbook Registration  State" },
        { name: "DMV Fee Changed" },
        { name: "DMV Title Status" },
        { name: "Notes" },
      ],
      msgcolor: {
        color: "black",
      },
      selecteddeal: "",
      notes: "",
      dealnotes: "",
      loan: "",
      message: "",
      name: "Pagination",
      currentPage: 1,
      totalPages: 0,
      dmvTitleDataList: [],
      dmvSalesPersons: [],
      dmvDealerNames: [],
          dealerDmv: [],
           reminderFlag: [],
      dmvLesseeNames: [],
      dmvYear: [],
      dmvMake: [],
      dmvModel: [],
      dmvVin:[],
      dmvDealerStates: [],
      selectedSalesperson: "",
      selectedDealer: "",
      selectedLessee: "",
      employeelist: [],
      employeemailids: [],
      userId: "",
      searchDetails: [],
      uploadingMessage: "",
      recordsUploaded: "",
      dmvLoanStatus: [],
      dealIds: [],
      serviceProviders: [],
      ServiceProviderExport: "SeviceProvider Data",
      serviceProviderExport: "SeriviceProvider Data",
      deal: this.initializeSearchCriteria(),
      activetab: "",
      message: "",
      selectedFile: "",
      userName: "",
      searchMessage: "",
      startDateMessage: "",
      endDateMessage: "",
    };
  },
  methods: {
    fetchdata() {
      //this.getDMVServiceProvider();
    },

    getemailids() {
      var that = this;
      that.employeemailids = [];
      $.each($("input[name='emailids']:checked"), function () {
        that.employeemailids.push($(this).val());
        //console.log(that.employeemailids);
      });
    },
    scrolltop() {
      window.scrollTo(0, 0);
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
    },
    listemailids() {
      // console.log("this");
      var checkList = document.getElementById("list1");
      var items = document.getElementById("items");

      // checkList.getElementsByClassName("anchor")[0].onclick = function(evt) {
      if (items.classList.contains("visible")) {
        items.classList.remove("visible");
        items.style.display = "none";
        //console.log("h");
      } else {
        items.classList.add("visible");
        items.style.display = "block";
        //console.log("k");
      }
      //};

      items.onblur = function (evt) {
        items.classList.remove("visible");
      };
    },
    selectedDeal(deal) {
      // console.log(deal);

      this.selecteddeal = deal.id;
      bus.$emit("dealerId", this.selecteddeal);
      this.userName = sessionStorage.getItem("USERNAME");
      //console.log(this.userName);
      bus.$emit("userName", this.userName);
      this.userId = sessionStorage.getItem("USERID");
      bus.$emit("userId", this.userId);
       this.loanStatusData = deal.dmvTitleStatus;
         bus.$emit("loanStatusData", this.loanStatusData);
      //bus.$emit("registrationState", deal.registrationState);
      //console.log(sessionStorage.setItem("USERNAME", this.userdata.userName));
      this.notes = "";
      this.scrolltop();
    },
    customLabel(option) {
      return `${option.loan}`;
    },
    lesseeLabel(option) {
      return `${option.lesseName}`;
    },
    DealerStateLabel(option) {
      return `${option.state}`;
    },
    yearLabel(option) {
      return `${option.year}`;
    },
    makeLabel(option) {
      return `${option.make}`;
    },
    modelLabel(option) {
      return `${option.model}`;
    },
    onUpload() {
      this.uploadingMessage = "";
      if (document.getElementById("uploadfile").value != "") {
        this.message = "";
        var modal = document.getElementById("myModal");
        modal.style.display = "block";
        const fd = new FormData();
        fd.append(
          "stateVehicleInfo",
          this.selectedFile,
          this.selectedFile.name
        );
        httpdmvtitle
          .post("/DMVTitle/upload", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            modal.style.display = "none";
            this.uploadingMessage = "Records Uploaded Successfully";
            this.recordsUploaded = "No of Records Uploaded:" + response.data;
            this.msgcolor.color = "green";
            setTimeout(() => {
              this.uploadingMessage = "";
              this.recordsUploaded = "";
            }, 3000);
            // this.uploadingMessage = "";
            // this.recordsUploaded = "";
            document.getElementById("uploadfile").value = null;
            this.getDMVServiceProvider();
          })
          .catch((e) => {
            console.log("Error in save data: " + e);
            if (e.message == "Request failed with status code 417") {
              this.uploadingMessage =
                "Could not upload the file: dmv service contacts CSVFile!";
              this.msgcolor.color = "Red";
              document.getElementById("uploadfile").value = null;
            } else if (e.message == "Request failed with status code 400") {
              this.uploadingMessage = "Please upload a csv file!";
              this.msgcolor.color = "Red";
              document.getElementById("uploadfile").value = null;
            } else {
              this.uploadingMessage = "";
            }
            this.failure = true;
            modal.style.display = "none";
          });
      } else {
        this.message = "choose a csv file";
        this.uploadingMessage = "";
      }
    },

    customLabel(option) {
      return `${option.loanStatus}`;
    },
    getDmvNotes() {
      //console.log(this.selecteddeal);
      httpdmvtitle
        .get("/DMVTitle/getDmvNotes", {
          params: {
            dmvId: this.selecteddeal,
          },
        })
        .then((response) => {
          this.dmvNotesList = response.data;
          //console.log(JSON.stringify(this.dmvNotesList));
        });
    },
    getDMVTitledata() {
      httpdmvtitle.get("/DMVTitle/getDMVTitleData").then((response) => {
        this.dmvTitleDataList = response.data;
        //console.log("DMV ADATA : " + JSON.stringify(this.dmvTitleDataList));
      });
    },

    getDmvDealIds() {
      httpdmvtitle.get("/DMVTitle/getDMVDeals").then((response) => {
        this.dealIds = response.data;
        if (this.dealIds.length == 1) {
          this.deal.loanId = this.dealIds[0];
        }
        // console.log(this.dealIds);
      });
    },

    getDMVSalesPersons() {
      httpdmvtitle.get("/DMVTitle/getDMVSalesPersonNames").then((response) => {
        this.dmvSalesPersons = response.data;
        if (this.dmvSalesPersons.length == 1) {
          this.deal.agentName = this.dmvSalesPersons[0];
        }
        //console.log(this.dmvSalesPersons);
      });
    },

    getDMVLoanStatus() {
      httpdmvtitle.get("/DMVTitle/getDMVLoanStatus").then((response) => {
        this.dmvLoanStatus = response.data;
        if (this.dmvLoanStatus.length == 1) {
          this.deal.loanStatus = this.dmvLoanStatus[0];
        }
        // console.log(this.dmvLoanStatus);
      });
    },

    getDMVLesseeNames() {
      httpdmvtitle.get("/DMVTitle/getDMVLesseeNames").then((response) => {
        this.dmvLesseeNames = response.data;
        if (this.dmvLesseeNames.length == 1) {
          this.deal.customerName = this.dmvLesseeNames[0];
        }
        // console.log(this.dmvLesseeNames);
      });
    },

    getDMVDealerNames() {
      httpdmvtitle.get("/DMVTitle/getDMVDealerNames").then((response) => {
        this.dmvDealerNames = response.data;
        if (this.dmvDealerNames.length == 1) {
          this.deal.dealerName = this.dmvDealerNames[0];
        }
        // console.log(this.dmvDealerNames);
      });
    },
     getDealerDmv() {
      httpdmvtitle.get("/DMVTitle/getDealerDmv").then((response) => {
        this.dealerDmv = response.data;
        if (this.dealerDmv.length == 1) {
          this.deal.dealerDmv = this.dealerDmv[0];
        }
        // console.log(this.dmvDealerNames);
      });
    },
getReminderFlag() {
      httpdmvtitle.get("/DMVTitle/getDMVReminderStoppedFlag").then((response) => {
        this.reminderFlag = response.data;
        if (this.reminderFlag.length == 1) {
          this.deal.reminderFlag = this.reminderFlag[0];
        }
        // console.log(this.dmvDealerNames);
      });
    },
    getDMVYear() {
      httpdmvtitle.get("/DMVTitle/getDMVYear").then((response) => {
        this.dmvYear = response.data;
        if (this.dmvYear.length == 1) {
          this.deal.selectedYear = this.dmvYear[0];
        }
        //console.log(this.dmvYear);
      });
    },

    getDMVMake() {
      httpdmvtitle.get("/DMVTitle/getDMVMake").then((response) => {
        this.dmvMake = response.data;
        if (this.dmvMake.length == 1) {
          this.deal.selectedMake = this.dmvMake[0];
        }
        // console.log(this.dmvMake);
      });
    },

    getDMVModel() {
      httpdmvtitle.get("/DMVTitle/getDMVModel").then((response) => {
        this.dmvModel = response.data;
        if (this.dmvModel.length == 1) {
          this.deal.selectedModel = this.dmvModel[0];
        }
        //console.log(this.dmvModel);
      });
    },

 getDMVVin() {
      httpdmvtitle.get("/DMVTitle/getDMVVin").then((response) => {
        this.dmvVin = response.data;
        if (this.dmvVin.length == 1) {
          this.deal.selectedVin = this.dmvVin[0];
        }
      
      });
    },


    getDMVDealerState() {
      httpdmvtitle.get("/DMVTitle/getDMVDealerState").then((response) => {
        this.dmvDealerStates = response.data;
        if (this.dmvDealerStates.length == 1) {
          this.deal.selectedDealerState = this.dmvDealerStates[0];
        }
        //console.log(this.dmvDealerStates);
      });
    },

    getDMVServiceProvider() {
      httpdmvtitle.get("/DMVTitle/getdmvserviceProvider").then((response) => {
        this.serviceProviders = response.data;
        this.serviceProviderExport =
          "ServiceProvider_" + moment(new Date()).format("MM-DD-YYYY") + ".csv";
        //console.log(this.this.serviceProviders);
      });
    },
    getStartDateData() {
     // console.log("START OF DATE");
      httpdmvtitle.get("/DMVTitle/getStartDate").then((response) => {
        // this.serviceProviders = response.data;

        this.deal.startDate = moment(new Date(response.data)).format(
          "YYYY-MM-DD"
        );

      //  console.log("Start1  : " + this.deal.startDate);
      });
    },

    getStartDate() {
      if (this.deal.startDate > this.deal.endDate) {
        this.startDateMessage = "Start Date Cannot be Greater than end date ";
      } else {
        this.startDateMessage = "";
        this.endDateMessage = "";
      }
    },
    getEndDate() {
      if (this.deal.endDate < this.deal.startDate) {
        this.endDateMessage = "End Date Cannot be less than start date ";
      } else {
        this.endDateMessage = "";
        this.startDateMessage = "";
      }
    },
    getDMVSearch() {
      let search = [];
      //console.log(JSON.stringify(this.deal.loanStatus.statusId));
      if (this.deal.startDate != this.deal.endDate) {
        search = {
          loan: this.deal.loanId,
          agentName: this.deal.agentName,
          dealerName: this.deal.dealerName,
          lesseeName: this.deal.customerName,
          year: this.deal.selectedYear,
          dealBookRegistrationState: this.deal.selectedDealerState,
          make: this.deal.selectedMake,
          model: this.deal.selectedModel,
          vin:this.deal.selectedVin,
          fromDate:
            this.deal.startDate == null
              ? null
              : moment(this.deal.startDate)
                  .subtract(1, "days")
                  .format("YYYY-MM-DD"),
          toDate:
            this.deal.endDate == null
              ? null
              : moment(this.deal.endDate).add(1, "days").format("YYYY-MM-DD"),

          dmvTitleStatus: this.deal.loanStatus.statusId,
           dealerDmv : this.deal.dealerDmv,
           reminderFlag : this.deal.reminderFlag
        };
      } else {
        search = {
          loan: this.deal.loanId,
          agentName: this.deal.agentName,
          dealerName: this.deal.dealerName,
          lesseeName: this.deal.customerName,
          year: this.deal.selectedYear,
          dealBookRegistrationState: this.deal.selectedDealerState,
          make: this.deal.selectedMake,
          model: this.deal.selectedModel,
          vin:this.deal.selectedVin,
          fromDate:
            this.deal.startDate == null
              ? null
              : moment(this.deal.startDate).format("YYYY-MM-DD"),
          toDate:
            this.deal.endDate == null
              ? null
              : moment(this.deal.endDate).format("YYYY-MM-DD"),

          dmvTitleStatus: this.deal.loanStatus.statusId,
          dealerDmv : this.deal.dealerDmv,
          reminderFlag : this.deal.reminderFlag
        };
      }
      if (
        this.deal.loanId == null &&
        this.deal.agentName == null &&
        this.deal.dealerName == null &&
        this.deal.customerName == null &&
        this.deal.selectedYear == null &&
        this.deal.selectedDealerState == null &&
        this.deal.make == null &&
        this.deal.model == null &&
        this.deal.startDate == null &&
        this.deal.endDate == null &&
        this.deal.loanStatus.statusId == null &&
          this.deal.dealerDmv == null &&
         this.deal.reminderFlag == null
      ) {
        this.msgcolor.color = "Red";
        this.searchMessage = "Provide atleast one Search criteria";
        //console.log("search");
      } else if (this.deal.startDate != null && this.deal.endDate == null) {
        this.message = "Enter end date";
      } else if (this.deal.startDate == null && this.deal.endDate != null) {
        this.message = "Enter start date";
      } else {
        this.searchMessage = "";
        this.message = "";
        httpdmvtitle.post("/DMVTitle/search", search).then((response) => {
          this.dmvTitleDataList = response.data;
          if (this.dmvTitleDataList.length === 0) {
            this.msgcolor.color = "Red";
            this.searchMessage = "No Data available for Selected Criteria";
          }
          // console.log(JSON.stringify(this.dmvTitleDataList));
        });
      }
    },

  
    receiveMessage(event) {
      if (
        event.data.type != "webpackWarnings" &&
        event.data.type != "webpackClose"
      ) {
        this.userdata = event.data;
        sessionStorage.setItem("JWT", this.userdata.jwt);
        sessionStorage.setItem("USERID", this.userdata.userId);
        sessionStorage.setItem("LOGGEDIN", true);
        sessionStorage.setItem("USERNAME", this.userdata.userName);
        this.getDMVLesseeNames();
        this.getDMVSalesPersons();
      this.getDMVTitledata();
        this.getDMVDealerNames();
        this.getDMVYear();
        this.getDMVMake();
        this.getDMVModel();
        this.getDMVVin();
        this.getDMVDealerState();
        this.getDmvDealIds();
        this.getDMVLoanStatus();
        this.getStartDateData();
         this.getDealerDmv();
         this.getReminderFlag();
        
        this.getDMVServiceProvider();
      }
    },

    getEmployeeDetails() {
      httpdmvtitle.get("/DMVTitle/getEmployeeDetails").then((response) => {
        this.employeelist = response.data;
        //console.log(response.data);
      });
    },
    saveDmvNotes() {
      // var emailids = this.employeemailids;
      // var email = [];
      // for (var i = 0; i < emailids.length; i++) {
      //   email.push(emailids[i].email);
      // }
      let dmvnotespayload = {
        loan: this.selecteddeal,
        notes: this.dealnotes,
        creationUserI: this.userId,
        emaiIds: this.employeemailids.toString(),
      };
      httpdmvtitle
        .post("/DMVTitle/saveDMVNotes", dmvnotespayload)
        .then((response) => {
          var x = document.getElementsByClassName("checkbox");
          //console.log(x);
          for (var i = 0; i < x.length; i++) {
            x[i].checked = false;
            //console.log(x[i].checked);
          }
          this.employeemailids = [];
          document.getElementById("items").style.display = "none";
          // x.array.forEach(element => {
          //   element.checked = false;
          // });
        });
    },
    initializeSearchCriteria() {
      return {
        loanId: null,
        dealerName: null,
        agentName: null,
        customerName: null,
        selectedDealerState: null,
        selectedYear: null,
        selectedMake: null,
        selectedModel: null,
        selectedVin:"",
        startDate: null,
        endDate: moment().format("YYYY-MM-DD"),
        loanStatus: [],
         dealerDmv :  null,
         reminderFlag : null
      };
    },
    resetSearchCriteria() {
      // console.log("g");
      this.deal = this.initializeSearchCriteria();
      this.searchMessage = "";
      this.startDateMessage = "";
      this.endDateMessage = "";
     this.getDMVTitledata();
      this.getStartDateData();
     
    },
    selectedNotes(name, dealid) {
      this.activetab = name;
      this.selecteddeal = dealid;
      // console.log(this.selecteddeal);
       this.userName = sessionStorage.getItem("USERNAME");
      //console.log(this.userName);
      bus.$emit("userName", this.userName);
      this.userId = sessionStorage.getItem("USERID");
      bus.$emit("userId", this.userId);
      bus.$emit("activetab", this.selecteddeal);
      bus.$emit("activeTabName", this.activetab);
      this.getDmvNotes();
    },
    displayFullName(option) {
      return `${option.firstName}  ,${
        option.lastName != null && option.lastName.length != 0
          ? option.lastName
          : ""
      }`;
    },
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage);

    this.fetchdata();
  },
};
</script>
<style scoped>
.wrap-text {
  white-space: nowrap;
}
.dropdown-check-list {
  display: inline-block;
}
.dropdown-check-list .anchor {
  position: relative;
  cursor: pointer;
  display: inline-block;
  padding: 5px 50px 5px 10px;
  border: 1px solid #ccc;
}
.dropdown-check-list .anchor:after {
  position: absolute;
  content: "";
  border-left: 2px solid black;
  border-top: 2px solid black;
  padding: 5px;
  right: 10px;
  top: 20%;
  -moz-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
  -o-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}
.dropdown-check-list .anchor:active:after {
  right: 8px;
  top: 21%;
}
.dropdown-check-list ul.items {
  padding: 2px;
  display: none;
  margin: 0;
  border: 1px solid #ccc;
  border-top: none;
}
.dropdown-check-list ul.items li {
  list-style: none ;
}
.rowwrap {
  margin-right: 0px !important;
  margin-left: 0px !important;
}
</style>
